import { DatabaseRecord } from ".";
import { parse } from "semver-ts";

export interface BuildInfo {
  version?: string;
  buildNumber?: string;
  commitSha?: string;
  runId?: string;
  workflow?: string;
  buildTimestamp?: string;
  channel?: string;
}

export interface BundleInfo extends BuildInfo {
  bundleId: string;
  forceUpdate?: boolean;
  downloadUrl?: string;
}

export interface AppVersionInfo {
  versionCode: number;
  versionName: string;
  compatibleVersionCodeMin: number;
  compatibleVersionCodeMax: number;
  compatibleVersion: string;
}

export interface UpdateBundle extends BundleInfo, DatabaseRecord {
  compatibleVersionCodeMin: number;
  compatibleVersionCodeMax: number;
  compatibleVersion: string;
}

export function getAppVersion(build: BuildInfo): AppVersionInfo {
  // Calculate version codes
  const version = parse(build.version!)!;
  const versionCode = Number(
    `${version.major}${version.minor.toString().padStart(4, "0")}${version.patch.toString().padStart(4, "0")}`
  );
  const versionName = `${version.major}.${version.minor}.${version.patch}`;
  const compatibleVersionCodeMin = Number(
    `${version.major}${version.minor.toString().padStart(4, "0")}${"0".padStart(4, "0")}`
  );
  const compatibleVersionCodeMax = Number(
    `${version.major}${version.minor.toString().padStart(4, "0")}${"9".padStart(4, "9")}`
  );

  return {
    versionCode,
    versionName,
    compatibleVersionCodeMin,
    compatibleVersionCodeMax,
    compatibleVersion: `${version.major}.${version.minor}`,
  };
}

export function getAppVersionFromCode(versionCode: number, versionName: string): AppVersionInfo {
  // Calculate version codes
  const version = parse(versionName)!;
  const compatibleVersionCodeMin = Number(
    `${version.major}${version.minor.toString().padStart(4, "0")}${"0".padStart(4, "0")}`
  );
  const compatibleVersionCodeMax = Number(
    `${version.major}${version.minor.toString().padStart(4, "0")}${"9".padStart(4, "9")}`
  );

  return {
    versionCode,
    versionName,
    compatibleVersionCodeMin,
    compatibleVersionCodeMax,
    compatibleVersion: `${version.major}.${version.minor}`,
  };
}

export function getLatestBundleId(channel: string, appVersion: AppVersionInfo) {
  return `${channel}-${appVersion.compatibleVersion}`;
}
